import { Flex, Icon, Label, LssProp } from '@lucidhq/lucidium';
import { Tooltip } from '@lucidhq/lucidium/components/Tooltip';
import { FC, ReactNode, SVGProps } from 'react';
import { MdInfo, MdInfoOutline } from 'react-icons/md';

export const IconVariants = {
  INFO: 'INFO',
  INFO_OUTLINE: 'INFO_OUTLINE',
} as const;

const icons: Record<string, FC<SVGProps<SVGSVGElement>>> = {
  [IconVariants.INFO]: MdInfo,
  [IconVariants.INFO_OUTLINE]: MdInfoOutline,
};

const ICON_SIZE = 18;

const labelWithTooltipLss: LssProp = { mr: 'sm' };

const iconWithTooltipLss: LssProp = { color: 'gray700', cursor: 'pointer' };

type IconType = keyof typeof IconVariants;

export interface LabelWithTooltipProps {
  children: ReactNode;
  title?: string;
  required?: boolean;
  labelLss?: LssProp;
  type?: IconType;
  size?: number;
  iconLss?: LssProp;
}

export const LabelWithTooltip = ({
  children,
  title,
  required = false,
  labelLss = labelWithTooltipLss,
  type = IconVariants.INFO,
  size = ICON_SIZE,
  iconLss = iconWithTooltipLss,
}: LabelWithTooltipProps) => (
  <Flex>
    <Label required={required} lss={labelLss}>
      {children}
    </Label>
    <Tooltip
      title={title}
      colorScheme="light"
      placement="right"
      enforceRefWrapper
    >
      <Icon size={size} as={icons[type]} lss={iconLss} />
    </Tooltip>
  </Flex>
);
